var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMediumFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 6C11.3137 6 14 8.68629 14 12C14 15.3137 11.3137 18 8 18C4.68629 18 2 15.3137 2 12C2 8.68629 4.68629 6 8 6ZM17 7C18.5 7 19.5 9.23858 19.5 12C19.5 14.7614 18.5 17 17 17C15.5 17 14.5 14.7614 14.5 12C14.5 9.23858 15.5 7 17 7ZM21 7.5C21.3809 7.5 21.712 8.32691 21.8809 9.74596L21.9266 10.1892C21.9333 10.266 21.9397 10.3441 21.9455 10.4237L21.9753 10.9176C21.9794 11.0026 21.9829 11.089 21.986 11.1766L21.9984 11.718C21.9995 11.8108 22 11.9048 22 12L21.9984 12.282L21.986 12.8234C21.9829 12.911 21.9794 12.9974 21.9753 13.0824L21.9455 13.5763C21.9397 13.6559 21.9333 13.734 21.9266 13.8108L21.8809 14.254C21.712 15.6731 21.3809 16.5 21 16.5C20.6191 16.5 20.288 15.6731 20.1191 14.254L20.0734 13.8108C20.0667 13.734 20.0603 13.6559 20.0545 13.5763L20.0247 13.0824C20.0206 12.9974 20.0171 12.911 20.014 12.8234L20.0016 12.282V11.718L20.014 11.1766C20.0171 11.089 20.0206 11.0026 20.0247 10.9176L20.0545 10.4237C20.0603 10.3441 20.0667 10.266 20.0734 10.1892L20.1191 9.74596C20.288 8.32691 20.6191 7.5 21 7.5Z",
    fill: "#FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumFill);
export default __webpack_public_path__ + "static/media/medium_fill.1cf8d53882d88fbcd712f2fb4ff7687f.svg";
export { ForwardRef as ReactComponent };